/** @jsx jsx */
import React, { useMemo, useState } from 'react';
import { Button, jsx } from 'theme-ui';
import { Stack } from '../grid';

import { Product } from './product';
import { useCart, useProductsVisible } from '../../cart-provider';
import { Chevron } from '../../icons';

export const ProductsList = ({ licenceKey, licenceTier, variants, products, typeface }) => {
  const [productsVisible, setProductsVisible] = useProductsVisible({ [typeface]: false });
  const { cart, ready } = useCart();

  // const [showAll, setShowAll] = useState(tr);

  const showAll = () => {
    setProductsVisible((state) => ({ ...state, [typeface]: true }));
  };

  const hideHidden = () => {
    setProductsVisible((state) => ({ ...state, [typeface]: false }));
  };

  const hasProductsInCart = useMemo(() => {
    if (!ready) return;

    const productsInCart = products.map((product) => {
      const cartProductKey = Object.keys(cart).find((key) => {
        return cart[key].categories.includes(product.slug.current);
      });

      return !cartProductKey ? false : cartProductKey.includes('family') ? false : true;
    }, {});

    return productsInCart.filter(Boolean).length > 0;
  }, [cart, ready, products]);

  const areProductsVisible = productsVisible[typeface] || hasProductsInCart;

  const singleStyles = products.filter((p) => p.isFamily !== true);
  const familyStyles = products.filter((p) => p.isFamily === true);

  return (
    <Stack gap={[6, 7]}>
      <Stack gap={[4]} key="family-list">
        {familyStyles.map((product) => (
          <Product
            key={`${product.slug.current}`}
            licenceKey={licenceKey}
            licenceTier={licenceTier}
            variants={variants}
            product={product}
            typeface={typeface}
          />
        ))}
      </Stack>

      <div
        sx={{ display: familyStyles.length === 0 || singleStyles.length < 8 ? 'none' : 'block' }}
      >
        <Button
          variant="medium_link"
          onClick={areProductsVisible ? hideHidden : showAll}
          pressed={areProductsVisible}
          disabled={hasProductsInCart}
        >
          {areProductsVisible
            ? 'Hide single styles'
            : `Show Single styles (${singleStyles.length})`}
        </Button>
      </div>

      <Stack gap={[4]} key="products-list">
        {singleStyles.map(
          (product) =>
            (!product.isHidden || areProductsVisible || hasProductsInCart) && (
              <Product
                key={`${product.slug.current}`}
                licenceKey={licenceKey}
                licenceTier={licenceTier}
                variants={variants}
                product={product}
                typeface={typeface}
              />
            )
        )}
      </Stack>
    </Stack>
  );
};
